module.exports = __webpack_public_path__ + "static/media/Tooltip.c2c6d004.svg";